import { Component, OnInit, ViewChild, HostListener, ElementRef } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { WaiterLoginModel } from 'src/app/share-modul/models/login/waiter-login.model';
import { VenueService } from '../../services/venues/venue.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-manager-pin-dialog',
  templateUrl: './manager-pin-dialog.component.html',
  styleUrls: ['./manager-pin-dialog.component.scss']
})
export class ManagerPinDialogComponent implements OnInit {
   public unsubscribe: Subject<void> = new Subject<void>();
   public loginModel: WaiterLoginModel = new WaiterLoginModel();
   public errorModel: { [k: string]: any } = {};
   public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
   public venueId: string;
   public spinner: boolean = false;
   public pinConfirmationOption: boolean;
   public keypad1: Array<any> = new Array<any>();
   public keypad2: Array<any> = new Array<any>();
   public keypad3: Array<any> = new Array<any>();
   public keypad4: Array<any> = new Array<any>();


   @ViewChild('inputPin') inputPin: ElementRef;

   @HostListener('document:keydown', ['$event'])
   handleKeyDown(event: KeyboardEvent) {
     this.inputPin.nativeElement.focus();
     if (!(event.key.match('^[0-9]') || event.key.startsWith('Backspace') )) {
       event.preventDefault();
     }
   }
   @HostListener('document:keyup', ['$event'])
   handleKeyUp(event: KeyboardEvent) {
     if(this.loginModel.pin.length == 4 && event.key.match('^[0-9]')){
       this.unpair(this.loginModel);
     }
   }
 
  constructor(
    public venueService: VenueService,
    private messageService: MessageService,
    public translate: TranslateService,
    public route: ActivatedRoute,
    public _router: Router,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
  ) {
    this.keypad1.push(1,2,3);
    this.keypad2.push(4,5,6);
    this.keypad3.push(7,8,9);
    this.keypad4.push(' ',0,'errase')
  }

  ngOnInit(): void {
    if (this.config.data != undefined ) {
      if(this.config.data.venueId) {
        this.venueId = this.config.data.venueId;
      }
      if(this.config.data.pinConfirmationOption){
        this.pinConfirmationOption = this.config.data.pinConfirmationOption;
      }
    }
  }
  public unpair(model: WaiterLoginModel): void {
    this.errorModel = {};
    this.spinner = true;
    if (!model.pin || model.pin.trim() === "") {
      this.errorModel['Pin'] = this.requiredFieldErrorMessage;
    }

    if (Object.keys(this.errorModel).length === 0) {
      if (this.venueId) {
        model.VenueId = this.venueId;
      }
      this.venueService.unpairdevice(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            if(response) {
              this.ref.close(true);
              this._router.navigate(['/waiter']);
            }else {
              this.ref.close(false);
              this.messageService.add({ severity: 'error', summary: 'Wrong credentials!', life: 2000 });
            }
          },
          error: errorResponse => {
            this.spinner = false;
            if (errorResponse.error.errors && errorResponse.error.errors.Pin) {
              errorResponse.error.errors.Pin.forEach((error: string) => {
                this.errorModel['Pin'] = error;
              });
            }
            if (errorResponse.error && errorResponse.error.Message) {
              this.messageService.add({ severity: 'error', summary: errorResponse.error.Message, life: 2000 });
            }
            else if (errorResponse.error && !errorResponse.error.errors) {
              this.messageService.add({ severity: 'error', summary: errorResponse.error.title, life: 2000 });
            }
          }
        });
    }
  }

  public addValue(item: any): void {
    if (this.loginModel.pin.length <= 3){
      if((item != ' ' && item != 'errase') || (item === 0)){
        this.loginModel.pin = this.loginModel.pin.concat(item);
      } else if(item == 'errase'){
        this.loginModel.pin = this.loginModel.pin.substring(0, -1);
      }
    }else {
      if(item == 'errase'){
        this.loginModel.pin = this.loginModel.pin.substring(0, -1);
      }
    }
    
    if(this.loginModel.pin.length == 4){
      if(this.pinConfirmationOption){
        this.ref.close(this.loginModel.pin)
      }else {
        this.unpair(this.loginModel);
      }
    }
  }

}
